export default {"src":"/_next/static/media/news-5.35b39d04.svg","height":62,"width":220,"blurWidth":0,"blurHeight":0};